const Intent = {
  ATTENTION: 'attention',
  DANGER: 'danger',
  INFO: 'info',
  NONE: 'none',
  PRIMARY: 'primary',
  SUCCESS: 'success',
  WARNING: 'warning'
};

export { Intent };
